import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VTooltip,
    {
      attrs: { "max-width": "400", top: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                VBtn,
                _vm._g(
                  {
                    attrs: { color: "success" },
                    on: {
                      click: function ($event) {
                        return _vm.getRelatorio()
                      },
                    },
                  },
                  on
                ),
                [_c(VIcon, [_vm._v("get_app")]), _vm._v(" BAIXAR PDF ")],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("span", [
        _vm._v("Clique para baixar o relatório dos dados em formato PDF."),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }